<template>
  <el-table
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :data="tableData"
    :default-sort="{ prop: sortedBy, order: listDirection }"
    @sort-change="onTableSortChange"
    border
    class="stock-table"
  >
    <!-- sortable -->
    <el-table-column
      prop="series"
      label="产品系列"
      sortable="custom"
      align="left"
      min-width="150"
    >
      <template slot-scope="scope">
        <span class="split-text" :title="scope.row.series">{{
          scope.row.series
        }}</span>
      </template>
      <!-- <template slot-scope="scope">
        {{scope.row.series==""?'暂无':scope.row.series}}
      </template>-->
    </el-table-column>
    <el-table-column
      prop="simpleCode"
      sortable="custom"
      label="简码"
      align="center"
    >
      <template slot-scope="scope">{{
        scope.row.simpleCode == "" ? "暂无" : scope.row.simpleCode
      }}</template>
    </el-table-column>
    <el-table-column
      prop="specification"
      align="center"
      sortable="custom"
      min-width="120"
      label="规格"
    >
      <template slot-scope="scope">{{
        scope.row.specification == "" ? "暂无" : scope.row.specification
      }}</template>
    </el-table-column>
    <el-table-column
      v-if="checkPermission(['EMPLOYEE'])"
      prop="color"
      sortable="custom"
      align="center"
      label="色号"
    >
      <template slot-scope="scope">{{
        scope.row.color == "" ? "暂无" : scope.row.color
      }}</template>
    </el-table-column>
    <el-table-column
      v-if="checkPermission(['EMPLOYEE'])"
      prop="grade"
      align="center"
      sortable="custom"
      width="80"
      label="等级"
    >
      <template slot-scope="scope">{{
        scope.row.grade == "" ? "暂无" : scope.row.grade
      }}</template>
    </el-table-column>
    <el-table-column
      v-if="checkPermission(['EMPLOYEE'])"
      prop="pack"
      align="left"
      sortable="custom"
      min-width="150"
      label="包装"
    >
      <template slot-scope="scope">
        <span class="split-text" :title="scope.row.pack">{{
          scope.row.pack
        }}</span>
      </template>
      <!-- <template slot-scope="scope">
        {{scope.row.pack==""?'暂无':scope.row.pack}}
      </template>-->
    </el-table-column>
    <el-table-column
      v-if="checkPermission(['EMPLOYEE'])"
      prop="reserveQuantity"
      align="center"
      sortable="custom"
      label="留货量"
    >
      <template slot-scope="scope">{{
        scope.row.reserveQuantity == "" ? "0" : scope.row.reserveQuantity
      }}</template>
    </el-table-column>
    <el-table-column
      prop="unitPerPack"
      align="center"
      sortable="custom"
      label="片/箱"
    ></el-table-column>
    <el-table-column
      prop="quantity"
      align="center"
      sortable="custom"
      width="120"
      label="可销售量"
    >
      <template slot-scope="scope"
        >{{ scope.row.quantity == "" ? "暂无" : scope.row.quantity }}
        {{ scope.row.unit == "" ? "暂无" : scope.row.unit }}</template
      >
    </el-table-column>
    <el-table-column
      prop="warehouse"
      align="center"
      sortable="custom"
      label="仓库"
      v-if="checkPermission(['EMPLOYEE'])"
    >
      <template slot-scope="scope">{{
        scope.row.warehouse == "" ? "暂无" : scope.row.warehouse
      }}</template>
    </el-table-column>
    <el-table-column
      v-if="checkPermission(['EMPLOYEE'])"
      prop="remark"
      align="center"
      sortable="custom"
      label="备注"
    >
      <template slot-scope="scope">
        <span class="split-text" :title="scope.row.remark">{{
          scope.row.remark
        }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { checkAuth } from "@/mixins";
import { checkPermission } from "@/utils/auth";
import { format } from "path";
export default {
  name: "pctable",
  mixins: [checkAuth],
  props: {
    sortedBy: {
      type: String,
      default: "",
    },
    listDirection: {
      type: String,
      default: "",
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    loading() {
      return this.$store.getters.stockLoading;
    },
  },
  methods: {
    checkPermission,
    onTableSortChange(val) {
      this.$emit("onChange", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.stock-table {
  .split-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
